import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LeaderboardPreview.module.css';

const LeaderboardPreview = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>Performance Incentives</h3>
      </div>
      <div className={styles.content}>
        <div className={styles.incentiveList}>
          <div className={styles.incentiveItem}>
            <div className={styles.incentiveDetails}>
              <span className={styles.rank}>1</span>
              <span className={styles.position}>First Place</span>
            </div>
            <span className={styles.reward}>60 minutes</span>
          </div>
          <div className={styles.incentiveItem}>
            <div className={styles.incentiveDetails}>
              <span className={styles.rank}>2</span>
              <span className={styles.position}>Second Place</span>
            </div>
            <span className={styles.reward}>30 minutes</span>
          </div>
          <div className={styles.incentiveItem}>
            <div className={styles.incentiveDetails}>
              <span className={styles.rank}>3</span>
              <span className={styles.position}>Third Place</span>
            </div>
            <span className={styles.reward}>15 minutes</span>
          </div>
        </div>
        <Link to="/leaderboard" className={styles.viewButton}>
          View Complete Leaderboard
        </Link>
      </div>
    </div>
  );
};

export default LeaderboardPreview;